import FastMarquee from "react-fast-marquee";
import { useLanguage } from "@/App";
import { translations } from "@/i18n";

const Marquee = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const items = [...t.marquee, ...t.marquee];

  return (
    <section
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-white/10 bg-[#060A1A] py-10"
    >
      <FastMarquee speed={35} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={`${lang}-${i}`} className="flex items-center">
            <span
              className={`whitespace-nowrap px-10 font-display text-5xl font-black tracking-widest md:text-7xl ${
                i % 3 === 0 ? "outline-text" : i % 3 === 1 ? "outline-text-gold" : "outline-text-red"
              }`}
            >
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-[#D4AF37]/60" />
          </span>
        ))}
      </FastMarquee>
    </section>
  );
};

export default Marquee;
